module.exports = __webpack_public_path__ + "static/media/7.02cff7cc.jpg";